/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of Asset. The values can be ESS or MACHINE. By Default it is MACHINE.
 *
 */
export var AssetSourceType;
(function (AssetSourceType) {
    AssetSourceType["MACHINE"] = "MACHINE";
    AssetSourceType["ESS"] = "ESS";
})(AssetSourceType || (AssetSourceType = {}));
